<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { loadFBX } from '../../Reusable/loadFBX'
// import { MeshStandardMaterial, LinearEncoding } from 'three'
// import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js'

export default {
  mixins: [
    O3DG2
  ],
  async mounted () {
    // let fbx = await loadFBX(require('file-loader!./fbx/iso-city.fbx'))
    // console.log(fbx)
    // function removeDuplicates( arr, prop ) {
    //   var obj = {};
    //   for ( var i = 0, len = arr.length; i < len; i++ ){
    //     if(!obj[arr[i][prop]]) obj[arr[i][prop]] = arr[i];
    //   }
    //   var newArr = [];
    //   for ( var key in obj ) newArr.push(obj[key]);
    //   return newArr;
    // }
    // let finger = (e, fprint) => {
    //   if (e.isMesh) {
    //     let attributes = e.geometry.attributes
    //     for (let kn in attributes) {
    //       let attr = attributes[kn]
    //       fprint[kn] = fprint[kn] || 0
    //       fprint[kn] += (attr.count * attr.itemSize) || 0
    //     }
    //     fprint['ob'] = fprint['ob'] || []
    //     fprint['ob'].push(e.name.split('_')[0] || '')
    //     fprint['ob'].sort((a, b) => {
    //       return a - b
    //     })
    //     console.log(fprint)
    //   }
    // }

    // let cleanList = (objs) => {
    //   objs.forEach((o) => {
    //     if (o.obj) {
    //       let fprint = {
    //       }
    //       finger(o.obj, fprint)
    //       o.obj.traverse((e) => {
    //         finger(e, fprint)
    //       })
    //       o.json = JSON.stringify(fprint)
    //     }
    //   })
    //   objs = removeDuplicates(objs, 'json')
    //   return objs
    // }

    // let objs = []

    // fbx.traverse(async (e) => {
    //   e.traverse(n => {
    //     // console.log(n)
    //     let item = n
    //     if (item.isMesh) {
    //       // console.log(item.material.name, item.material)
    //       let oMat = item.material
    //       item.material = new MeshStandardMaterial({ color: oMat.color, map: oMat.map })

    //       if (item.material.map) {
    //         item.material.map.encoding = LinearEncoding
    //       }
    //       if (item.material.alphaMap) {
    //         item.material.alphaMap.encoding = LinearEncoding
    //       }
    //       if (item.material.metalnessMap) {
    //         item.material.metalnessMap.encoding = LinearEncoding
    //       }
    //       if (item.material.normalMap) {
    //         item.material.normalMap.encoding = LinearEncoding
    //       }
    //       if (item.material.roughnessMap) {
    //         item.material.roughnessMap.encoding = LinearEncoding
    //       }
    //       objs.push({
    //         obj: item,
    //         json: ''
    //       })
    //     }
    //   })
    // })
    // objs = cleanList(objs)
    // console.log(objs)

    // this.element.addEventListener('click', async (ev) => {
    //   let download = (obj) => {
    //     return new Promise(async (resolve) => {
    //       var link = document.createElement('a')
    //       link.style.display = 'none';
    //       document.body.appendChild( link ); // Firefox workaround, see #6594
    //       function save ( blob, filename ) {
    //         link.href = URL.createObjectURL( blob );
    //         link.download = filename;
    //         link.click();

    //         // URL.revokeObjectURL( url ); breaks Firefox...
    //       }

    //       function saveArrayBuffer( buffer, filename ) {
    //         save(new Blob([ buffer ], { type: 'application/octet-stream' }), filename);
    //       }
    //       // // function saveString( text, filename ) {
    //       // //   save( new Blob( [ text ], { type: 'text/plain' } ), filename );
    //       // // }
    //       // let buffer = await provideArrayBuffer(data);
    //       // saveArrayBuffer(buffer, data.obj.downloadName);
    //       // resolve()

    //       // await rafSleep()
    //       // let bloblURL = await getBlobFromArrayBuffer(arrayBuffer)



    //       var gltfExporter = new GLTFExporter();
    //       var options = {
    //         binary: true,
    //       };

    //       gltfExporter.parse(obj, function (result) {
    //         if ( result instanceof ArrayBuffer ) {
    //           saveArrayBuffer(result, obj.downloadName);
    //         }

    //         // console.log(result)

    //         // zip.folder(data.type).file(obj.downloadName + '.glb', result)

    //         // resolve(URL.createObjectURL( new Blob([result], { type: 'application/octet-stream' }) ));
    //         resolve()
    //       }, options );
    //     })
    //   }

    //   if (!ev.shiftKey) {
    //     return
    //   }
    //   let tsk = []
    //   objs.forEach((o, i) => {
    //     o.obj.downloadName = `Mesh___TYPE___${o.obj.name || o.key}.glb`
    //     tsk.push({
    //       fn: () => {
    //         console.log('start', i, (objs.length - 1), o.name)
    //         return download(o.obj, o, {})
    //           .then((v) => {
    //             console.log('end', i, (i / (objs.length - 1) * 100).toFixed(2) + '%')
    //             return v
    //           })
    //       }
    //     })
    //   })
    //   for (let i = 0; i < tsk.length; i += 1) {
    //     if (i % 25 === 0) {
    //       await tsk[i].fn()
    //     } else {
    //       await tsk[i].fn()
    //     }
    //   }
    // })
    // // this.o3d.add(fbx)
  }
}
</script>

<style>

</style>